module.exports = __webpack_public_path__ + "static/media/user.a396b5a7.svg";